export const ACTION_TYPES = {
  COMPANY_IS_SAVED: 'COMPANY_IS_SAVED',
  USER_FAVOURITE_COMPANIES: 'USER_FAVOURITE_COMPANIES',
};

const initialState = {
  companyIsSaved: false,
  userFavouriteCompanies: [],
};

const CompanyPage = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.COMPANY_IS_SAVED:
      return { ...state, companyIsSaved: action.payload };
    case ACTION_TYPES.USER_FAVOURITE_COMPANIES:
      return { ...state, userFavouriteCompanies: action.payload };
    default:
      return state;
  }
};
export default CompanyPage;
